import { render, staticRenderFns } from "./MobilePage.vue?vue&type=template&id=0a092d66&scoped=true&"
import script from "./MobilePage.vue?vue&type=script&lang=js&"
export * from "./MobilePage.vue?vue&type=script&lang=js&"
import style0 from "./MobilePage.vue?vue&type=style&index=0&id=0a092d66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a092d66",
  null
  
)

export default component.exports